import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';

import TagSearchItem from './TagSearchItem';

class TagSearchGroup extends PureComponent {
  sortSubcategories = () => {
    const { groupName, tags } = this.props;
    if (groupName === 'subcategories') {
      return sortBy(tags, [tag => tag.categories[0].id]);
    } else {
      return tags;
    }
  };

  renderTags = () => {
    const { onChange } = this.props;
    return this.sortSubcategories().map((tag, i) => {
      return (
        <li className="TagSearchGroup-item" key={i}>
          <TagSearchItem tag={tag} onClick={onChange} />
        </li>
      );
    });
  };
  render() {
    return (
      <React.Fragment>
        <span className="TagSearchGroup-title">{this.props.groupName}</span>
        <ul className="TagSearchGroup">{this.renderTags()}</ul>
      </React.Fragment>
    );
  }
}

TagSearchGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  groupName: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
};

export default TagSearchGroup;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/TagSearchBar/TagSearchGroup.js